import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  MessagingConnectChatWebSocketParams,
  MessagingCreateChatRoom201,
  MessagingCreateChatRoomBody,
  MessagingDeleteMessage200,
  MessagingGetChatMessages200,
  MessagingGetChatMessagesParams,
  MessagingGetChatRoomById200,
  MessagingGetChatRooms200,
  MessagingGetChatRoomsParams,
  MessagingLeaveChatRoom200,
  MessagingSendMessage201,
  MessagingSendMessageBody
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * @summary 채팅방 목록 조회
 */
export const messagingGetChatRooms = (
    params?: MessagingGetChatRoomsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MessagingGetChatRooms200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/chat/rooms`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getMessagingGetChatRoomsQueryKey = (params?: MessagingGetChatRoomsParams,) => {
    return [`https://api.ugot.uk/api/chat/rooms`, ...(params ? [params]: [])] as const;
    }

    
export const getMessagingGetChatRoomsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof messagingGetChatRooms>>, TError = AxiosError<unknown>>(params?: MessagingGetChatRoomsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingGetChatRooms>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingGetChatRoomsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingGetChatRooms>>> = ({ signal }) => messagingGetChatRooms(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingGetChatRooms>>, TError, TData> & { queryKey: QueryKey }
}

export type MessagingGetChatRoomsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof messagingGetChatRooms>>>
export type MessagingGetChatRoomsInfiniteQueryError = AxiosError<unknown>

/**
 * @summary 채팅방 목록 조회
 */
export const useMessagingGetChatRoomsInfinite = <TData = Awaited<ReturnType<typeof messagingGetChatRooms>>, TError = AxiosError<unknown>>(
 params?: MessagingGetChatRoomsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingGetChatRooms>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMessagingGetChatRoomsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMessagingGetChatRoomsQueryOptions = <TData = Awaited<ReturnType<typeof messagingGetChatRooms>>, TError = AxiosError<unknown>>(params?: MessagingGetChatRoomsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof messagingGetChatRooms>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingGetChatRoomsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingGetChatRooms>>> = ({ signal }) => messagingGetChatRooms(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingGetChatRooms>>, TError, TData> & { queryKey: QueryKey }
}

export type MessagingGetChatRoomsQueryResult = NonNullable<Awaited<ReturnType<typeof messagingGetChatRooms>>>
export type MessagingGetChatRoomsQueryError = AxiosError<unknown>

/**
 * @summary 채팅방 목록 조회
 */
export const useMessagingGetChatRooms = <TData = Awaited<ReturnType<typeof messagingGetChatRooms>>, TError = AxiosError<unknown>>(
 params?: MessagingGetChatRoomsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof messagingGetChatRooms>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMessagingGetChatRoomsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary 채팅방 생성
 */
export const messagingCreateChatRoom = (
    messagingCreateChatRoomBody: MessagingCreateChatRoomBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MessagingCreateChatRoom201>> => {
    
    return axios.post(
      `https://api.ugot.uk/api/chat/rooms`,
      messagingCreateChatRoomBody,options
    );
  }



export const getMessagingCreateChatRoomMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingCreateChatRoom>>, TError,{data: MessagingCreateChatRoomBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof messagingCreateChatRoom>>, TError,{data: MessagingCreateChatRoomBody}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingCreateChatRoom>>, {data: MessagingCreateChatRoomBody}> = (props) => {
          const {data} = props ?? {};

          return  messagingCreateChatRoom(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MessagingCreateChatRoomMutationResult = NonNullable<Awaited<ReturnType<typeof messagingCreateChatRoom>>>
    export type MessagingCreateChatRoomMutationBody = MessagingCreateChatRoomBody
    export type MessagingCreateChatRoomMutationError = AxiosError<unknown>

    /**
 * @summary 채팅방 생성
 */
export const useMessagingCreateChatRoom = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingCreateChatRoom>>, TError,{data: MessagingCreateChatRoomBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof messagingCreateChatRoom>>,
        TError,
        {data: MessagingCreateChatRoomBody},
        TContext
      > => {

      const mutationOptions = getMessagingCreateChatRoomMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary 채팅방 상세 조회
 */
export const messagingGetChatRoomById = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MessagingGetChatRoomById200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/chat/rooms/${id}`,options
    );
  }


export const getMessagingGetChatRoomByIdQueryKey = (id: number,) => {
    return [`https://api.ugot.uk/api/chat/rooms/${id}`] as const;
    }

    
export const getMessagingGetChatRoomByIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof messagingGetChatRoomById>>, TError = AxiosError<unknown>>(id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingGetChatRoomById>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingGetChatRoomByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingGetChatRoomById>>> = ({ signal }) => messagingGetChatRoomById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingGetChatRoomById>>, TError, TData> & { queryKey: QueryKey }
}

export type MessagingGetChatRoomByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof messagingGetChatRoomById>>>
export type MessagingGetChatRoomByIdInfiniteQueryError = AxiosError<unknown>

/**
 * @summary 채팅방 상세 조회
 */
export const useMessagingGetChatRoomByIdInfinite = <TData = Awaited<ReturnType<typeof messagingGetChatRoomById>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingGetChatRoomById>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMessagingGetChatRoomByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMessagingGetChatRoomByIdQueryOptions = <TData = Awaited<ReturnType<typeof messagingGetChatRoomById>>, TError = AxiosError<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof messagingGetChatRoomById>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingGetChatRoomByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingGetChatRoomById>>> = ({ signal }) => messagingGetChatRoomById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingGetChatRoomById>>, TError, TData> & { queryKey: QueryKey }
}

export type MessagingGetChatRoomByIdQueryResult = NonNullable<Awaited<ReturnType<typeof messagingGetChatRoomById>>>
export type MessagingGetChatRoomByIdQueryError = AxiosError<unknown>

/**
 * @summary 채팅방 상세 조회
 */
export const useMessagingGetChatRoomById = <TData = Awaited<ReturnType<typeof messagingGetChatRoomById>>, TError = AxiosError<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof messagingGetChatRoomById>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMessagingGetChatRoomByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary 채팅방 나가기
 */
export const messagingLeaveChatRoom = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MessagingLeaveChatRoom200>> => {
    
    return axios.delete(
      `https://api.ugot.uk/api/chat/rooms/${id}`,options
    );
  }



export const getMessagingLeaveChatRoomMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingLeaveChatRoom>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof messagingLeaveChatRoom>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingLeaveChatRoom>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  messagingLeaveChatRoom(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MessagingLeaveChatRoomMutationResult = NonNullable<Awaited<ReturnType<typeof messagingLeaveChatRoom>>>
    
    export type MessagingLeaveChatRoomMutationError = AxiosError<unknown>

    /**
 * @summary 채팅방 나가기
 */
export const useMessagingLeaveChatRoom = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingLeaveChatRoom>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof messagingLeaveChatRoom>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getMessagingLeaveChatRoomMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary 채팅방 메시지 목록 조회
 */
export const messagingGetChatMessages = (
    id: number,
    params?: MessagingGetChatMessagesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MessagingGetChatMessages200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/chat/rooms/${id}/messages`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getMessagingGetChatMessagesQueryKey = (id: number,
    params?: MessagingGetChatMessagesParams,) => {
    return [`https://api.ugot.uk/api/chat/rooms/${id}/messages`, ...(params ? [params]: [])] as const;
    }

    
export const getMessagingGetChatMessagesInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof messagingGetChatMessages>>, TError = AxiosError<unknown>>(id: number,
    params?: MessagingGetChatMessagesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingGetChatMessages>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingGetChatMessagesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingGetChatMessages>>> = ({ signal }) => messagingGetChatMessages(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingGetChatMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type MessagingGetChatMessagesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof messagingGetChatMessages>>>
export type MessagingGetChatMessagesInfiniteQueryError = AxiosError<unknown>

/**
 * @summary 채팅방 메시지 목록 조회
 */
export const useMessagingGetChatMessagesInfinite = <TData = Awaited<ReturnType<typeof messagingGetChatMessages>>, TError = AxiosError<unknown>>(
 id: number,
    params?: MessagingGetChatMessagesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingGetChatMessages>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMessagingGetChatMessagesInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMessagingGetChatMessagesQueryOptions = <TData = Awaited<ReturnType<typeof messagingGetChatMessages>>, TError = AxiosError<unknown>>(id: number,
    params?: MessagingGetChatMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof messagingGetChatMessages>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingGetChatMessagesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingGetChatMessages>>> = ({ signal }) => messagingGetChatMessages(id,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingGetChatMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type MessagingGetChatMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof messagingGetChatMessages>>>
export type MessagingGetChatMessagesQueryError = AxiosError<unknown>

/**
 * @summary 채팅방 메시지 목록 조회
 */
export const useMessagingGetChatMessages = <TData = Awaited<ReturnType<typeof messagingGetChatMessages>>, TError = AxiosError<unknown>>(
 id: number,
    params?: MessagingGetChatMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof messagingGetChatMessages>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMessagingGetChatMessagesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary 메시지 전송
 */
export const messagingSendMessage = (
    id: number,
    messagingSendMessageBody: MessagingSendMessageBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MessagingSendMessage201>> => {
    
    return axios.post(
      `https://api.ugot.uk/api/chat/rooms/${id}/messages`,
      messagingSendMessageBody,options
    );
  }



export const getMessagingSendMessageMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingSendMessage>>, TError,{id: number;data: MessagingSendMessageBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof messagingSendMessage>>, TError,{id: number;data: MessagingSendMessageBody}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingSendMessage>>, {id: number;data: MessagingSendMessageBody}> = (props) => {
          const {id,data} = props ?? {};

          return  messagingSendMessage(id,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MessagingSendMessageMutationResult = NonNullable<Awaited<ReturnType<typeof messagingSendMessage>>>
    export type MessagingSendMessageMutationBody = MessagingSendMessageBody
    export type MessagingSendMessageMutationError = AxiosError<unknown>

    /**
 * @summary 메시지 전송
 */
export const useMessagingSendMessage = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingSendMessage>>, TError,{id: number;data: MessagingSendMessageBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof messagingSendMessage>>,
        TError,
        {id: number;data: MessagingSendMessageBody},
        TContext
      > => {

      const mutationOptions = getMessagingSendMessageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary 메시지 삭제
 */
export const messagingDeleteMessage = (
    id: number,
    messageId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MessagingDeleteMessage200>> => {
    
    return axios.delete(
      `https://api.ugot.uk/api/chat/rooms/${id}/messages/${messageId}`,options
    );
  }



export const getMessagingDeleteMessageMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingDeleteMessage>>, TError,{id: number;messageId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof messagingDeleteMessage>>, TError,{id: number;messageId: number}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof messagingDeleteMessage>>, {id: number;messageId: number}> = (props) => {
          const {id,messageId} = props ?? {};

          return  messagingDeleteMessage(id,messageId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MessagingDeleteMessageMutationResult = NonNullable<Awaited<ReturnType<typeof messagingDeleteMessage>>>
    
    export type MessagingDeleteMessageMutationError = AxiosError<unknown>

    /**
 * @summary 메시지 삭제
 */
export const useMessagingDeleteMessage = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof messagingDeleteMessage>>, TError,{id: number;messageId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof messagingDeleteMessage>>,
        TError,
        {id: number;messageId: number},
        TContext
      > => {

      const mutationOptions = getMessagingDeleteMessageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary 웹소켓 연결
 */
export const messagingConnectWebSocket = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    return axios.get(
      `https://api.ugot.uk/ws`,options
    );
  }


export const getMessagingConnectWebSocketQueryKey = () => {
    return [`https://api.ugot.uk/ws`] as const;
    }

    
export const getMessagingConnectWebSocketInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof messagingConnectWebSocket>>, TError = AxiosError<void>>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingConnectWebSocket>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingConnectWebSocketQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingConnectWebSocket>>> = ({ signal }) => messagingConnectWebSocket({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingConnectWebSocket>>, TError, TData> & { queryKey: QueryKey }
}

export type MessagingConnectWebSocketInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof messagingConnectWebSocket>>>
export type MessagingConnectWebSocketInfiniteQueryError = AxiosError<void>

/**
 * @summary 웹소켓 연결
 */
export const useMessagingConnectWebSocketInfinite = <TData = Awaited<ReturnType<typeof messagingConnectWebSocket>>, TError = AxiosError<void>>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingConnectWebSocket>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMessagingConnectWebSocketInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMessagingConnectWebSocketQueryOptions = <TData = Awaited<ReturnType<typeof messagingConnectWebSocket>>, TError = AxiosError<void>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof messagingConnectWebSocket>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingConnectWebSocketQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingConnectWebSocket>>> = ({ signal }) => messagingConnectWebSocket({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingConnectWebSocket>>, TError, TData> & { queryKey: QueryKey }
}

export type MessagingConnectWebSocketQueryResult = NonNullable<Awaited<ReturnType<typeof messagingConnectWebSocket>>>
export type MessagingConnectWebSocketQueryError = AxiosError<void>

/**
 * @summary 웹소켓 연결
 */
export const useMessagingConnectWebSocket = <TData = Awaited<ReturnType<typeof messagingConnectWebSocket>>, TError = AxiosError<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof messagingConnectWebSocket>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMessagingConnectWebSocketQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary 채팅 웹소켓 연결
 */
export const messagingConnectChatWebSocket = (
    params: MessagingConnectChatWebSocketParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<unknown>> => {
    
    return axios.get(
      `https://api.ugot.uk/ws/chat`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getMessagingConnectChatWebSocketQueryKey = (params: MessagingConnectChatWebSocketParams,) => {
    return [`https://api.ugot.uk/ws/chat`, ...(params ? [params]: [])] as const;
    }

    
export const getMessagingConnectChatWebSocketInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof messagingConnectChatWebSocket>>, TError = AxiosError<void>>(params: MessagingConnectChatWebSocketParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingConnectChatWebSocket>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingConnectChatWebSocketQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingConnectChatWebSocket>>> = ({ signal }) => messagingConnectChatWebSocket(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingConnectChatWebSocket>>, TError, TData> & { queryKey: QueryKey }
}

export type MessagingConnectChatWebSocketInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof messagingConnectChatWebSocket>>>
export type MessagingConnectChatWebSocketInfiniteQueryError = AxiosError<void>

/**
 * @summary 채팅 웹소켓 연결
 */
export const useMessagingConnectChatWebSocketInfinite = <TData = Awaited<ReturnType<typeof messagingConnectChatWebSocket>>, TError = AxiosError<void>>(
 params: MessagingConnectChatWebSocketParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof messagingConnectChatWebSocket>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMessagingConnectChatWebSocketInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getMessagingConnectChatWebSocketQueryOptions = <TData = Awaited<ReturnType<typeof messagingConnectChatWebSocket>>, TError = AxiosError<void>>(params: MessagingConnectChatWebSocketParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof messagingConnectChatWebSocket>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMessagingConnectChatWebSocketQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof messagingConnectChatWebSocket>>> = ({ signal }) => messagingConnectChatWebSocket(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof messagingConnectChatWebSocket>>, TError, TData> & { queryKey: QueryKey }
}

export type MessagingConnectChatWebSocketQueryResult = NonNullable<Awaited<ReturnType<typeof messagingConnectChatWebSocket>>>
export type MessagingConnectChatWebSocketQueryError = AxiosError<void>

/**
 * @summary 채팅 웹소켓 연결
 */
export const useMessagingConnectChatWebSocket = <TData = Awaited<ReturnType<typeof messagingConnectChatWebSocket>>, TError = AxiosError<void>>(
 params: MessagingConnectChatWebSocketParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof messagingConnectChatWebSocket>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getMessagingConnectChatWebSocketQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



